module.exports = __webpack_public_path__ + "static/2-2-a5b1c2b628ab8baa12bf3b629c927366.jpg";